import { TS_Charges }         from '../TravelSeller/Models/TS_Charges';
import { BookingItemInterface } from './BookingItemInterface';

export class Charges extends TS_Charges implements BookingItemInterface {}